<script lang="ts">
	import type { Snippet } from 'svelte';
	import type { ClassValue } from 'svelte/elements';

	interface Props {
		gridClass?: ClassValue;
		mobileMargin?: boolean;
		desktopMargin?: boolean;
		class?: ClassValue;
		children: Snippet;
	}

	let {
		gridClass,
		mobileMargin = true,
		desktopMargin = true,
		class: className,
		children
	}: Props = $props();
</script>

<div
	class={[
		'w-full lg:mx-auto lg:max-w-[1408px]',
		...(Array.isArray(className) ? className : [className])
	]}
>
	<div
		class={[
			'grid grid-cols-4 gap-x-6 lg:grid-cols-12',
			...(Array.isArray(gridClass) ? gridClass : [gridClass]),
			{
				'max-lg:mx-6': mobileMargin,
				'lg:mx-[18px]': desktopMargin
			}
		]}
	>
		{@render children()}
	</div>
</div>
